import { List, ListItem, Typography } from '@mui/material';
import { Container } from '@mui/system';
import { createSelector } from '@reduxjs/toolkit';
import { AppModels, AppState, FileAttrs, fileSelector, routeParams } from 'cdx-common';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { MainSimpleViewLoader } from '../libraries/MainViewLoader';
import { useUploadManager } from '../libraries/UploadManager';
import { MasterViewPage } from './MasterPage';



export const UploadTest = () => {
    return <MasterViewPage>
        <MainSimpleViewLoader
            path={routeParams.uploadTest.path}>
            <LoadedUploadTest />
        </MainSimpleViewLoader>
    </MasterViewPage>;
};

const concernedFile = createSelector([
    (state: AppState) => fileSelector.selectAll(state)
], (files: FileAttrs[]) => {
    return files.filter(p => p.relatedType === AppModels.appInstances);
});


export const LoadedUploadTest = () => {

    const { droppable, undroppable } = useUploadManager();
    const [isOver, setIsOver] = useState(false);

    const files = useSelector((state: AppState) => concernedFile(state));

    const boxRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const ref = boxRef.current;
        if (ref) {
            droppable({
                relation: {
                    type: AppModels.appInstances,
                    id: '',
                },
                element: ref,
                onDragOver: () => { setIsOver(true); },
                onDragOut: () => { setIsOver(false); },
                onDrop: () => { }
            });
        }

        return () => {
            if (ref) {
                undroppable(ref);
            }
        };

    }, [boxRef]);
    return <Container maxWidth={false}>
        <Typography variant='h1'>Téléversement de fichier test 2</Typography>
        <div ref={boxRef} style={{ borderWidth: '5px', borderStyle: 'solid', borderColor: isOver ? 'black' : 'white' }}>
            La liste des fichiers apparait ici
            <List>{files.map(FileListItem)}</List>
        </div>
    </Container>;
};

const FileListItem = (file: FileAttrs) => {
    return <ListItem key={file.id}> <Typography>{file.name}</Typography></ListItem>;
};
